export default __webpack_public_path__ + "static/media/user4.d41d5187.png";